import React from "react";

const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <h3 className="text-[13px] font-semibold text-slate-500
                 uppercase tracking-[0.07em]
                 m-0 mb-[18px]">
    {children}
  </h3>
);

export default SectionTitle;